var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('span',{staticClass:"text-base"},[(_vm.savingComment)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e()])],_c('b-form-textarea',{attrs:{"size":"lg","debounce":500,"value":_vm.text,"placeholder":_vm.$t('title.comments'),"rows":"3","disabled":_vm.disabled},on:{"update":_vm.changeProductComment}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }